// Used to determine which component to render for
// the dropshipping status page
export enum Pages {
  Status = 'status',
  RedCard = 'redcard',
  BankOnboarding = 'bankonboarding',
  ABN = 'abn'
}
